export const SET_LOADING = '@permissions/SET_LOADING';
export const SAVE_DATA = '@permissions/SAVE_DATA';



// WEBPACK FOOTER //
// ./src/Modules/Permissions/constants.js